import React from 'react';
import { useHistory } from 'react-router-dom';

import { Button } from '@material-ui/core';

import './ButtonLikeTabs.scss';

export default function ButtonLikeTabs(props) {
  const { text1, text2, disabled, link, } = props;
  const history = useHistory();

  return (
    <div className="wrapper" style={{ display: "flex" }}>
      <Button
        onClick={() => { history.push(link) }}
        className="TabLeft"
        variant="contained"
        disabled={disabled == 'text1'}

      >
        {text1}
      </Button>
      <Button
        onClick={() => { history.push(link) }}
        className="TabRight"
        variant="contained"
        disabled={disabled == 'text2'}
      >
        {text2}
      </Button>
    </div>
  );
}

